import { Dialog } from "@mui/material";
import { Checkbox } from "@vds/checkboxes";
import { Icon } from "@vds/icons";
import { TextArea } from "@vds/inputs";
import { Loader } from "@vds/loaders";
import { ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Notification } from "@vds/notifications";
import { Body, Title } from "@vds/typography";
import { useState } from "react";
import { EVENTS_INFO_CONSTANTS } from "../../../global/constants/constants";

const BulkResolveEventsModal = ({
  showResolveEvents,
  setShowResolveEvents,
  handleResolveIncident,
  loader,
  actionType,
  unresolvedCount = 0,
  selectedCount = 0,
}) => {
  const [resolveNotes, setResolveNotes] = useState("");
  const [isCheckboxSelected, setIsCheckBoxSelected] = useState(false);

  // Determine event count based on action type
  const eventCount = actionType === "bulkfilter" ? unresolvedCount : selectedCount;
  const isSingleEvent = eventCount === 1;
  return (
    <Dialog
      aria-label="Resolve event modal"
      fullWidthh={true}
      maxWidth={"md"}
      open={showResolveEvents?.isOpen}
      disableOutsideClick={true}
      surface="light"
    >
      <div style={{ margin: "3% 3% 5% 3%" }}>
        <ModalTitle>
          <Title size="large" bold>
            {isSingleEvent ? EVENTS_INFO_CONSTANTS.RESOLVE_SINGLE_EVENT_TITLE : EVENTS_INFO_CONSTANTS.RESOLVE_BULK_EVENTS_TITLE}
          </Title>
        </ModalTitle>
        <div
          style={{
            cursor: "pointer",
            position: "absolute",
            right: "25px",
            top: "25px",
          }}
          data-testid="eventsInfo_closeResolveEventsModal"
          onClick={(e) => {
            setShowResolveEvents({ isOpen: false });
          }}
        >
          <Icon name="close" />
        </div>

        <ModalBody>
          <Body size="large">
            <Notification type="warning" hideCloseButton={true} subtitle="">
              <h6>
                {isSingleEvent
                  ? EVENTS_INFO_CONSTANTS.RESOLVE_SINGLE_EVENT_WARNING
                  : EVENTS_INFO_CONSTANTS.RESOLVE_BULK_EVENTS_WARNING}
              </h6>
              {!isSingleEvent && eventCount > 0 && (
                <h6 style={{ marginTop: "10px", fontWeight: "bold" }}>
                  Total events to be resolved: {eventCount}
                </h6>
              )}
            </Notification>
          </Body>
          <br />
          <TextArea
            label="Comment"
            surface="light"
            readOnly={false}
            required={false}
            disabled={false}
            error={false}
            errorText="Enter a valid resolution notes."
            helperText=""
            helperTextPlacement="bottom"
            maxLength={200}
            onChange={(e) => {
              setResolveNotes(e.target.value);
            }}
          />
          <div style={{ marginTop: "2rem" }}>
            <Checkbox
              name={"This event was accurately detected"}
              width="auto"
              disabled={false}
              error={false}
              selected={isCheckboxSelected}
              id="eventsInfo_resolveEventsModalDetectionCheckbox"
              onChange={(e) => {
                setIsCheckBoxSelected(!isCheckboxSelected);
              }}
            >
              {isSingleEvent
                ? EVENTS_INFO_CONSTANTS.RESOLVE_SINGLE_EVENT_CONFIRM
                : EVENTS_INFO_CONSTANTS.RESOLVE_BULK_EVENTS_CONFIRM}
            </Checkbox>
          </div>
        </ModalBody>
        <ModalFooter
          buttonData={{
            primary: {
              width: "100%",
              children: "Resolve",
              disabled: !isCheckboxSelected,
              "data-testid": "eventsInfo_resolveEventsModalPrimaryButton",
              onClick: () => {
                handleResolveIncident(resolveNotes, actionType);
                setIsCheckBoxSelected(false);
              },
            },
          }}
        />
      </div>
      {loader ? <Loader active={loader} fullscreen={false} /> : ""}
    </Dialog>
  );
};

export default BulkResolveEventsModal;
